import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

/**
 * One-time renewal notice for clients in the Aetna program.
 *
 * Informational only - there is nothing to accept, so both the OK button and the
 * title bar's X do the same thing: dismiss it. Closing is the dismissal, and the
 * caller is responsible for persisting that (see utils/aetnaRenewalNotice.js).
 */
const AetnaRenewalNoticeModal = ({ onClose }) => {
  return (
    <Dialog
      title={"Important Renewal Information"}
      onClose={onClose}
      width={620}
    >
      <div style={{ padding: "10px 15px" }}>
        <p>
          As part of this year's renewal process, PrestigePEO evaluated
          healthcare options across our carrier portfolio in response to rising
          healthcare costs and significant renewal increases occurring
          throughout the market.
        </p>
        <p>
          In collaboration with your PrestigePEO Benefits team, we encourage
          you to review available plan options to determine the best fit for
          your organization and employees.
        </p>
      </div>
      <DialogActionsBar layout={"end"}>
        <Button themeColor={"primary"} onClick={onClose}>
          {"OK"}
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default AetnaRenewalNoticeModal;
